import { TrygroupPatternType } from '../../../../services/trygroup-dashboard/trygroup-personal-analysis.service'
import { toCircledNumber } from '../ka-labels'

const DIAGNOSIS_STATUSES = {
  good: { key: 'good', symbol: '◎', label: '良い調子' },
  ok: { key: 'ok', symbol: '○', label: '安定' },
  warning: { key: 'warning', symbol: '▲', label: '注意ポイント' },
  priority: { key: 'priority', symbol: '×', label: '優先課題' },
} as const

export type KeyActionDiagnosisStatus =
  (typeof DIAGNOSIS_STATUSES)[keyof typeof DIAGNOSIS_STATUSES]

/** ヒット回数からキーアクション診断の状態を導出する。 */
export function deriveKeyActionDiagnosisStatus(
  hitCount: number,
): KeyActionDiagnosisStatus {
  if (!Number.isInteger(hitCount) || hitCount < 0) {
    throw new Error(`hitCount must be a non-negative integer: ${hitCount}`)
  }

  if (hitCount === 0) {
    return DIAGNOSIS_STATUSES.good
  }

  if (hitCount === 1) {
    return DIAGNOSIS_STATUSES.ok
  }

  if (hitCount === 2) {
    return DIAGNOSIS_STATUSES.warning
  }

  return DIAGNOSIS_STATUSES.priority
}

/** ヒット回数が重点克服対象（優先課題）の水準かを判定する。 */
export function isPriorityHitCount(hitCount: number): boolean {
  return deriveKeyActionDiagnosisStatus(hitCount).key === 'priority'
}

/** KA ID とパターン ID から表示用の診断観点コードを生成する。 */
export function buildDiagnosisViewpointCode(
  kaId: number,
  patternId: number,
): string {
  const circledPatternId = toCircledNumber(patternId)
  if (circledPatternId == null) {
    return `${kaId}-${patternId}`
  }

  return `${kaId}-${circledPatternId}`
}

/** ヒット回数の条件を満たす場合だけ課題タイプの表示名を返す。 */
export function getPatternTypeLabel(
  patternType: TrygroupPatternType | null,
  hitCount: number,
): 'NGトーク' | '必要な説明不足' | null {
  if (patternType == null || hitCount < 2) {
    return null
  }

  // 課題タイプの許可値追加時にフォールバックで誤ラベルにならないよう網羅 switch にする
  // （全ケースを列挙しない場合は戻り値型に undefined が混ざりコンパイルエラーになる）
  switch (patternType) {
    case 'ng_talk':
      return 'NGトーク'
    case 'missing':
      return '必要な説明不足'
  }
}
